import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { lockPrimaryFont, lockSecondaryFont } from '../../store/actions/fonts';
import { showEmbedDialog } from '../../store/actions/embed';
import { showSignInDialog } from '../../store/actions/signin';
import FlatButton from 'material-ui/FlatButton';
import { getFontUrlName } from '../../helpers/fonts';
import ActionLockOutline from 'material-ui/svg-icons/action/lock-outline';
import ActionSwapHoriz from 'material-ui/svg-icons/action/swap-horiz';
import ActionCode from 'material-ui/svg-icons/action/code';
import ContentSave from 'material-ui/svg-icons/content/save';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import './FontBar.css';

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    lockPrimaryFont: (fontName) => {
      dispatch(lockPrimaryFont(fontName));
    },
    lockSecondaryFont: (fontName) => {
      dispatch(lockSecondaryFont(fontName));
    },
    showEmbedDialog: () => {
      dispatch(showEmbedDialog());
    },
    showSignInDialog: () => {
      dispatch(showSignInDialog());
    }
  }
}

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    lockedPrimary: state.lockedPrimary,
    lockedSecondary: state.lockedSecondary
  }
}

class FontBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      whiteBackground: false,
      previousTop: 0,
      menuOpen: false,
    }
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleLockPrimary = this.toggleLockPrimary.bind(this);
    this.toggleLockSecondary = this.toggleLockSecondary.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.swapFonts = this.swapFonts.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  goHome() {
    browserHistory.push('/');
  }

  showMenu() {
    this.setState({
      menuOpen: true,
    });
  }

  closeMenu() {
    this.setState({
      menuOpen: false,
    });
  }

  handleScroll() {
    const shrinkOn = 60;
    const currentTop = (window.pageYOffset || document.documentElement.scrollTop)
      - (document.documentElement.clientTop || 0);

    if (currentTop < shrinkOn) {
      this.setState({
        whiteBackground: false,
        previousTop: currentTop
      });
    }
    else {
      this.setState({
        whiteBackground: true,
        previousTop: currentTop
      });
    }
  }

  toggleLockPrimary() {
    const {
      lockPrimaryFont,
      fonts,
      lockedPrimary
    } = this.props;

    const primaryName = getFontUrlName(fonts.primary.name);
    if (lockedPrimary === primaryName)
      lockPrimaryFont('');
    else
      lockPrimaryFont(primaryName);
  }

  toggleLockSecondary() {
    const {
      lockSecondaryFont,
      fonts,
      lockedSecondary
    } = this.props;

    const secondaryName = getFontUrlName(fonts.secondary.name);
    if (lockedSecondary === secondaryName)
      lockSecondaryFont('');
    else
      lockSecondaryFont(secondaryName);
  }

  swapFonts() {
    const {
      fonts,
      lockPrimaryFont,
      lockSecondaryFont
    } = this.props;
    lockPrimaryFont('');
    lockSecondaryFont('');
    const primaryName = getFontUrlName(fonts.primary.name)
    const secondaryName = getFontUrlName(fonts.secondary.name)
    browserHistory.push('/' + secondaryName + '+' + primaryName);
  }

  renderMobileMenu() {
    const {
      fonts,
      lockedPrimary,
      lockedSecondary
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    return (
      <div className="open-mobile-menu-container">
        <NavigationClose className="close-mobile-menu-icon"
          onClick={this.closeMenu} />
          <div className="pairings-container">
            Pairing
            <div className="font-bar-button-container">
              <FlatButton style={{
                  height: 60,
                  fontFamily: primary.name,
                }}
                className="font-bar-button"
                label={getFontUrlName(primary.name) === lockedPrimary
                  ? <div className="locked-container">
                      {primary.name}
                      <ActionLockOutline className="lock-icon" />
                    </div>
                  : primary.name}
                onClick={this.toggleLockPrimary} />
            </div>
            with
            <div className="font-bar-button-container">
              <FlatButton style={{
                  height: 60,
                  fontFamily: secondary.name,
                }}
                className="font-bar-button"
                label={getFontUrlName(secondary.name) === lockedSecondary
                  ? <div className="locked-container">
                      {secondary.name}
                      <ActionLockOutline className="lock-icon" />
                    </div>
                  : secondary.name}
                onClick={this.toggleLockSecondary} />
            </div>
          </div>
          <FlatButton style={{
              height: 60,
            }}
            onClick={this.swapFonts}
            className="font-bar-action-button"
            label={<span>
                <ActionSwapHoriz className="font-bar-action-icon" />
                <span className="font-bar-action-label">
                  Swap
                </span>
              </span>} />
          <FlatButton style={{
              height: 60,
            }}
            className="font-bar-action-button"
            label={<span>
              <ActionCode className="font-bar-action-icon" />
              <span className="font-bar-action-label">
                Embed
              </span>
            </span>}
            onClick={this.props.showEmbedDialog} />
          <FlatButton style={{
              height: 60,
            }}
            className="font-bar-action-button"
            label={<span>
              <ContentSave className="font-bar-action-icon" />
              <span className="font-bar-action-label">
                Save
              </span>
            </span>}
            onClick={this.props.showSignInDialog} />
      </div>
    )
  }

  renderPairings() {
    const {
      fonts,
      lockedPrimary,
      lockedSecondary
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    let textColor = ' light-text-color';
    if (this.state.whiteBackground) {
      textColor = ' dark-text-color';
    }

    return (
      <div className="font-bar-additional-content-container">
        <div className="pairings-container">
          Pairing
          <div className="font-bar-button-container">
            <FlatButton style={{
                height: 60,
                fontFamily: primary.name,
              }}
              className={"font-bar-button" + textColor}
              label={getFontUrlName(primary.name) === lockedPrimary
                ? <div className="locked-container">
                    {primary.name}
                    <ActionLockOutline className="lock-icon" />
                  </div>
                : primary.name}
              onClick={this.toggleLockPrimary} />
          </div>
          with
          <div className="font-bar-button-container">
            <FlatButton style={{
                height: 60,
                fontFamily: secondary.name,
              }}
              className={"font-bar-button" + textColor}
              label={getFontUrlName(secondary.name) === lockedSecondary
                ? <div className="locked-container">
                    {secondary.name}
                    <ActionLockOutline className="lock-icon" />
                  </div>
                : secondary.name}
              onClick={this.toggleLockSecondary} />
          </div>
        </div>
        <div className="font-bar-container-right">
          <FlatButton style={{
              height: 60,
            }}
            onClick={this.swapFonts}
            className={"font-bar-action-button" + textColor}
            label={<span>
                <ActionSwapHoriz className={"font-bar-action-icon"  + textColor} />
                <span className="font-bar-action-label">
                  Swap
                </span>
              </span>} />
          <FlatButton style={{
              height: 60,
            }}
            className={"font-bar-action-button" + textColor}
            label={<span>
              <ActionCode className={"font-bar-action-icon"  + textColor} />
              <span className="font-bar-action-label">
                Embed
              </span>
            </span>}
            onClick={this.props.showEmbedDialog} />
          <FlatButton style={{
              height: 60,
            }}
            className={"font-bar-action-button" + textColor}
            label={<span>
              <ContentSave className={"font-bar-action-icon"  + textColor} />
              <span className="font-bar-action-label">
                Save
              </span>
            </span>}
            onClick={this.props.showSignInDialog} />
        </div>
      </div>
    )
  }

  render() {
    const {
      menuOpen
    } = this.state;
    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    let rootClassName = 'font-bar-wrapper';
    let textColor = ' light-text-color';
    if (this.state.whiteBackground) {
      rootClassName += ' white-background';
      textColor = ' dark-text-color';
    }

    if (primary && primary.name && secondary && secondary.name) {
      return (
        <div className={rootClassName}>
          <div className="font-bar-container">
            <div className="font-bar-desktop">
              <div className={"mixfont--header" + textColor}
                onClick={this.goHome}>
                MIXFONT
              </div>
              {this.renderPairings()}
            </div>
            <div className="font-bar-mobile">
              {menuOpen
                ? this.renderMobileMenu()
                : <div className="mobile-menu-icon-container">
                    <NavigationMenu className={"mobile-menu-icon" + textColor}
                      onClick={this.showMenu} />
                    <div className={"mixfont--header" + textColor}
                      onClick={this.goHome}>
                      MIXFONT
                    </div>
                  </div>}
            </div>
          </div>
        </div>
      )
    }
    else {
      return (
        <div className="font-bar-wrapper">
          <div className="font-bar-container">
            <div className="font-bar-text">
              Loading ... just a second ...
            </div>
          </div>
        </div>
      )
    }
  }
}

export default FontBar = connect(mapStateToProps, mapDispatchToProps)(FontBar);



// WEBPACK FOOTER //
// ./src/components/generator/FontBar.jsx